import { placeOfSupplyFromGstin } from '@diagon-alley/common';
import { useEffect } from 'react';

/**
 * Place of supply follows the BILL TO GSTIN.
 *
 * A Haryana brand buying from a Maharashtra manufacturer for delivery to its 3PL in Mumbai is a
 * bill-to/ship-to supply: the law deems the buyer to have received the goods at its own
 * registered place of business, so the place of supply is Haryana and the tax is IGST, not
 * Maharashtra CGST+SGST that the buyer could not even claim back. Where the goods land decides
 * it only when there is no Bill To GSTIN, which is why the Ship To side may seed the state only
 * while this has nothing to say.
 *
 * FILLED, NOT FORCED, the same contract every seed on these forms follows: a state picked by
 * hand wins and is never overwritten.
 *
 * Returns whether the place of supply is currently held, by hand or by the Bill To GSTIN, so
 * the Ship To handlers know to leave it alone.
 */
export function usePlaceOfSupplyFromBillTo(
    billToGstin: string,
    pickedByHand: boolean,
    setStateCode: (code: string | null) => void,
): boolean {
    const billToState = placeOfSupplyFromGstin(billToGstin);

    useEffect(() => {
        if (!pickedByHand && billToState) setStateCode(billToState);
    }, [billToState, pickedByHand, setStateCode]);

    return pickedByHand || billToState !== null;
}
